import React, { Component, Fragment } from "react";
import { observer } from "mobx-react";
import { Form, Drawer, Select, InputNumber, Button, Checkbox, Input } from "antd";

const FormItem = Form.Item;
const Option = Select.Option;

@Form.create({})
@observer
export default class ArticleForgeDrawer extends Component {
	constructor(props) {
		super(props);
	}

	downloadArticle = () => {
		this.props.form.validateFieldsAndScroll((err, vals) => {
			if (err != null) {
				return;
			}
			this.props.downloadArticleForgeArticle({
				articleSource: "ArticleForge",
				inputInfo: JSON.stringify({
					keyword: vals.keyword,
					subKeywords: vals.subKeywords,
					length: vals.length					
				})
			});
		});
	};

	render() {
		const {
			ui: { articleForgeDrawerVisible, downloadingArticleForgeArticle }
		} = this.props;

		return (
			<Drawer
				title="Download Article Forge Article"
				placement="top"
				closable={false}
				onClose={this.props.hideDrawer}
				visible={articleForgeDrawerVisible}
				height={500}
			>
				<Form>
					<FormItem label="Keywords" style={{ marginBottom: 10 }}>
						{this.props.form.getFieldDecorator("keyword", {
							rules: [
								{
									required: true,
									message: "You need to enter keywords"
								}
							]
						})(
							<Input type="text"/>
						)}
					</FormItem>
					<FormItem label="Sub Keywords" style={{ marginBottom: 10 }}>
						{this.props.form.getFieldDecorator("subKeywords")(
							<Input type="text"/>
						)}
					</FormItem>
					<FormItem label="Length" style={{ marginBottom: 10 }}>
						{this.props.form.getFieldDecorator("length", {
							rules: [
								{
									required: true,
									message: "You need to select article length"
								}
							]
						})(
							<Select style={{ width: 200 }}>
								<Option key="very_short" value="very_short">Very Short (~50 Words)</Option>
								<Option key="short" value="short">Short (~200 Words)</Option>
								<Option key="medium" value="medium">Medium (~500 Words)</Option>
								<Option key="long" value="long">Long (~750 Words)</Option>		
							</Select>
						)}
					</FormItem>					
					{/* <FormItem>
						{this.props.form.getFieldDecorator(`spinArticle`, {
							valuePropName: "checked"
						})(<Checkbox>Also spin the article</Checkbox>)}
					</FormItem> */}
					<div
						style={{
							position: "absolute",
							bottom: 0,
							width: "100%",
							borderTop: "1px solid #e8e8e8",
							padding: "10px 16px",
							textAlign: "left",
							left: 0,
							background: "#fff",
							borderRadius: "0 0 4px 4px"
						}}
					>
						<Button
							style={{
								marginRight: 8
							}}
							onClick={this.props.hideDrawer}
						>
							Cancel
						</Button>
						<Button
							type="primary"
							onClick={this.downloadArticle}
							loading={downloadingArticleForgeArticle}
						>
							Save
						</Button>
					</div>
				</Form>
			</Drawer>
		);
	}
}
